<!-- Outer root container -->
<ac-container (CheckBoxEvent.selectedChanged)="controller.enabledChanged($event)" width="fill" height="fill" padding-horizontal="16" padding-vertical="16" auto-layout="vertical" gap-vertical="16">
	<!-- Topbar Container -->
	<ac-container width="fill" alignment="center" gap-horizontal="auto">
		<!-- Icon Header Container -->
		<ac-container alignment="center" gap-horizontal="8">
			<ac-icon name="flag-01"></ac-icon>
			<ac-label [text]="'setup.sidebar.featureflagsadmin' | translate" variant="dark" size="large"></ac-label>
		</ac-container>
	</ac-container>
	<!-- Services -->
	@for (service of model.services; track service) {
		<ac-container width="fill" height="hug" fill="#F5F7FA" corner-radius="8" padding-horizontal="16" padding-vertical="16" auto-layout="vertical" gap-vertical="8">
			<ac-label variant="dark" size="large" [text]="service.name"></ac-label>
			<!-- Flag Cards Container -->
			<ac-container width="fill" auto-layout="grid" min-column-width="448">
				@for (flag of service.flags; track flag) {
					<ac-stroke-container width="fill" corner-radius="8" padding-horizontal="0" padding-vertical="0" [fill]="model.cardColor(flag)">
						<!-- Top Bar -->
						<ac-container width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
							<!-- Icon Ring -->
							<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0" [fill]="model.cardColor(flag)">
								<ac-icon name="flag-01"></ac-icon>
							</ac-stroke-container>
							<ac-label width="fill" [text]="flag.name" variant="dark"></ac-label>
						</ac-container>
						<!-- Divider -->
						<ac-divider></ac-divider>
						<!-- Created At Container -->
						<ac-container auto-layout="vertical" width="fill" padding-horizontal="16" padding-vertical="12" gap-vertical="8">
							<ac-label width="fill" truncate="false" variant="dark" [text]="flag.description"></ac-label>
							<ac-container width="fill" gap-horizontal="16">
								<ac-label width="fill" [text]="'setup.featureflagsadmin.created' | translate" variant="light"></ac-label>
								<ac-label [text]="model.toDateString(flag.createdAt)"></ac-label>
							</ac-container>
							<ac-container width="fill" gap-horizontal="16">
								<ac-label width="fill" [text]="'setup.featureflagsadmin.turnsOn' | translate" variant="light"></ac-label>
								<ac-label [text]="model.toDateString(flag.expiresAt)"></ac-label>
							</ac-container>
							<ac-container width="fill" gap-horizontal="8">
								<ac-label width="fill" [text]="'setup.featureflagsadmin.activates' | translate" variant="light"></ac-label>
								@if (!model.flagExpired(flag) && model.toDaysLeft(flag.expiresAt) < 7) {
									<ac-icon name="alert-triangle" variant="warning"></ac-icon>
								}
								@if (model.flagExpired(flag)) {
									<ac-label [text]="'setup.featureflagsadmin.expired' | translate"></ac-label>
								} @else {
									<ac-label [text]="model.toDaysLeft(flag.expiresAt) + ' ' + ('setup.featureflagsadmin.days' | translate)"></ac-label>
								}
							</ac-container>
						</ac-container>
						<!-- Divider -->
						<ac-divider></ac-divider>
						<ac-container width="fill" gap-horizontal="16" alignment="left" padding-horizontal="16" padding-vertical="16">
							<ac-label width="fill" variant="light" [text]="'setup.featureflagsadmin.turnedOn' | translate"></ac-label>
							<ac-check-box [selected]="$safeNavigationMigration(flag.variants.at(0)?.enabled)" [item]="flag"></ac-check-box>
						</ac-container>
					</ac-stroke-container>
				}
			</ac-container>
		</ac-container>
	}
</ac-container>

<!-- Confirmation Dialog -->
<dialog #confirmationDialog closedby="none">
	<ac-stroke-container width="400" height="hug" padding-horizontal="0" padding-vertical="0" clip-content="true" hide-scrollbars="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="flag-01"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'setup.featureflagsadmin.confirmHeader' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<ac-container width="fill" padding-horizontal="16" padding-vertical="16" auto-layout="vertical" gap-vertical="16">
			<ac-label width="fill" truncate="false" [text]="model.confirmBody"></ac-label>
			<ac-label width="fill" truncate="false" [text]="'setup.featureflagsadmin.propagationNotice' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="controller.hideConfirmationDialog()" [enabled]="!model.updatingFlags" icon="x-close" [text]="'setup.featureflagsadmin.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.confirmationSave()" [enabled]="!model.updatingFlags" icon="check-circle" [text]="'setup.featureflagsadmin.continue' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<!-- Network Error Dialog -->
<dialog #networkErrorDialog closedby="none">
	<ac-stroke-container width="360" height="hug" padding-horizontal="0" padding-vertical="0" clip-content="true" hide-scrollbars="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="alert-circle"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'setup.featureflagsadmin.noConnection' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<ac-container width="fill" alignment="left" padding-horizontal="16" padding-vertical="16">
			<ac-label width="fill" truncate="false" [text]="'setup.featureflagsadmin.networkError' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="model.hideNetworkErrorDialog()" icon="x-close" [text]="'setup.featureflagsadmin.close' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<!-- Unknown Error Dialog -->
<dialog #unknownErrorDialog closedby="none">
	<ac-stroke-container width="360" height="hug" padding-horizontal="0" padding-vertical="0" clip-content="true" hide-scrollbars="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="alert-circle"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'setup.featureflagsadmin.unknownErrorLabel' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<ac-container width="fill" padding-horizontal="16" padding-vertical="16">
			<ac-label width="fill" truncate="false" [text]="'setup.featureflagsadmin.unknownError' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="model.hideUnknownErrorDialog()" icon="x-close" [text]="'setup.featureflagsadmin.close' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>
